import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import { useAuth } from '../contexts/AuthContext';
import { canAccessPath, defaultPathForRole, roleOf } from '../utils/roles';
import { pathnameOf, safeReturnPath } from '../utils/returnTo';

// /login: the form for someone signed out; for someone signed in, the page they were heading for
// (/login?next=...), or their home when there is none or their role cannot open it.
export default function LoginRoute() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  if (!user) return <LoginPage />;
  const role = roleOf(user);
  const next = safeReturnPath(params.get('next'));
  const to = next && canAccessPath(role, pathnameOf(next)) ? next : defaultPathForRole(role);
  return <Navigate to={to} replace />;
}
